import React from 'react';

interface LogoProps {
  size?: number;
  className?: string;
  color?: string;
}

export const Logo: React.FC<LogoProps> = ({ size = 24, className = '', color = 'currentColor' }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g transform="rotate(15 50 50)">
        {/* Kij */}
        <rect x="47" y="5" width="6" height="35" rx="3" fill={color} />
        
        {/* Nasada */}
        <path d="M50 35 C 40 35, 35 45, 35 50 L 65 50 C 65 45, 60 35, 50 35 Z" fill={color} />
        
        {/* Paski przewiązania - zrobione z przerwy (szczeliny) w głównej bryle, lub tym samym kolorem z delikatnym obniżeniem krycia, by uniknąć brudzenia grafiki */}
        <rect x="34" y="52" width="32" height="3" fill={color} opacity="0.5" />
        <rect x="33" y="57" width="34" height="3" fill={color} opacity="0.5" />
        
        {/* Włosie */}
        <path d="M32 62 L 40 62 L 38 90 L 25 90 Z" fill={color} />
        <path d="M42 62 L 49 62 L 49 90 L 41 90 Z" fill={color} />
        <path d="M51 62 L 58 62 L 59 90 L 51 90 Z" fill={color} />
        <path d="M60 62 L 68 62 L 75 90 L 62 90 Z" fill={color} />
      </g>
    </svg>
  );
};

export default Logo;
